var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)"
    },
    d: "M512,137.067v301.867c0,18.133-13.867,32-32,32H32c-18.133,0-32-13.867-32-32V137.067 c0-17.067,13.867-32,32-32h448C498.133,105.067,512,118.933,512,137.067z",
    id: "id_101"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(144, 152, 153)"
    },
    d: "M512,216v-78.933c0-17.067-13.867-32-32-32H32c-18.133,0-32,14.933-32,32V216H512z",
    id: "id_102"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(178, 204, 30)"
    },
    cx: 289.067,
    cy: 287.467,
    r: 145.067,
    id: "id_103"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(0, 0, 0)"
    },
    cx: 289.067,
    cy: 287.467,
    r: 106.667,
    id: "id_104"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(28, 153, 151)"
    },
    cx: 289.067,
    cy: 287.467,
    r: 62.933,
    id: "id_105"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(23, 230, 227)"
    },
    cx: 332.8,
    cy: 260.8,
    r: 26.667,
    id: "id_106"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "M118.4,181.867H49.067c-5.333,0-9.6-4.267-9.6-9.6v-19.2c0-5.333,4.267-9.6,9.6-9.6H118.4 c5.333,0,9.6,4.267,9.6,9.6v19.2C128,177.6,123.733,181.867,118.4,181.867z",
    id: "id_107"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(45, 67, 71)"
    },
    d: "M106.667,75.2h-38.4c-5.333,0-9.6,4.267-9.6,9.6V104h57.6V85.867 C116.267,79.467,112,75.2,106.667,75.2z",
    id: "id_108"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(49, 72, 77)"
    },
    d: "M347.733,41.067H230.4c-10.667,0-19.2,6.4-22.4,16l-16,48h196.267l-16-48 C368,47.467,358.4,41.067,347.733,41.067z",
    id: "id_109"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.63c254f67c973e720adfd6603cf1eae9.svg";
export { ForwardRef as ReactComponent };